<template>
    <div class="base-form">
        <el-form ref="form" :model="form" :rules="rules" label-width="123px" class="form-box">
            <div class="form-title"><Title text="基本信息"></Title></div>
            <el-form-item label="广告主公司名称" prop="company">
                <el-input v-model="form.company" placeholder="请输入广告公司名称，最多256个字"></el-input>
            </el-form-item>
            <el-form-item label="品牌" prop="brand">
                <el-select v-model="form.brand" filterable placeholder="请选择品牌" style="width: 100%">
                    <el-option v-for="item in brands" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
                <el-tooltip effect="light" placement="top" content="没有找到品牌，请选择其他">
                    <img class="form-tip-icon" :src="iconTip" />
                </el-tooltip>
            </el-form-item>
            <el-form-item label="合作产品" prop="product">
                <el-select
                    v-model="form.product"
                    multiple
                    filterable
                    remote
                    :remote-method="_fetchProduct"
                    placeholder="请选择合作产品"
                    style="width: 100%"
                >
                    <el-option v-for="item in products" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
                <el-tooltip effect="light" placement="top" content="没有找到产品，请联系运营添加">
                    <img class="form-tip-icon" :src="iconTip" />
                </el-tooltip>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" :loading="submitLoading" @click="submitFormAction('form')">
                    &nbsp;提&nbsp;交&nbsp;
                </el-button>
                <el-button @click="backAction">&nbsp;取&nbsp;消&nbsp;</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import QuRequest from '@/core/QuRequest';
import Title from '@/components/Title';
import $conf from '@/common/conf';
import IconTip from '@/assets/image/icon/tip-icon.png';

const request = new QuRequest();

export default {
    name: 'AdvertiserManagePrivateAddAder',
    components: { Title },
    computed: {
        brands () {
            return this.config.filter(i => i.type === $conf.configType.brands.id);
        }
        // products () {
        //     return this.config.filter(i => i.type === $conf.configType.products.id);
        // }
    },
    data () {
        return {
            products: [],
            iconTip: IconTip,
            submitLoading: false,
            form: {
                customer_id: '',
                company: '',
                brand: '',
                product: []
            },
            rules: {
                company: [
                    { required: true, message: '广告主公司名称必填', type: 'string', triggle: 'blur' },
                    { min: 1, max: 256, message: `长度为1-256`, triggle: 'blur' },
                    {
                        pattern: /^[\u4e00-\u9fffa-zA-Z\d\s|\\(|\\)|\\（|\\）]+$/,
                        message: '只能包含汉字、英文字母、数字、中英文括号、英文单词等',
                        triggle: 'blur'
                    }
                ],
                brand: [{ required: true, message: '品牌名必填', type: 'string', triggle: 'change' }],
                product: [{ required: true, type: 'array', message: '产品必填', triggle: 'change' }]
            }
        };
    },
    props: {
        config: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    methods: {
        async _fetchProduct (key) {
            try {
                const params = {
                    name: key || '',
                    page_size: 5000
                };
                const res = await request.send(request.Apis.sales.product.productRead, params);
                this.products = [...res.data.data];
            } catch (err) {
                console.error(`获取产品失败：${err.message || '未知错误'}`);
            }
        },

        // 获取详情
        async _getDetail () {
            const toArr = val => (val ? (val || '').split(',') : []);
            try {
                const params = {
                    customer_id: this.form.customer_id
                };
                const res = await request.send(request.Apis.sales.customer.detail, params);
                const company = (res.data || {}).company || {};

                this.form = {
                    ...this.form,
                    company: company.company,
                    brand: company.brand,
                    product: toArr(company.product)
                };
            } catch (err) {
                this.$message.error(`获取详情失败：${err.message || '未知错误'}`);
            }
        },

        // async 预检查大客户
        async processCheckBigCustomer (cb = () => {}) {
            try {
                this.submitLoading = true;
                const res = await request
                    .send(request.Apis.sales.customer.isBigCustomer, {
                        company: this.form.company
                    })
                    .fin(() => {
                        this.submitLoading = false;
                    });
                const flag = (res.data || {}).type || false;
                cb(flag);
            } catch (err) {
                this.$message.error(`检查失败：${err.message || '未知错误'}`);
            }
        },

        // async 提交
        async processSubmit () {
            try {
                this.submitLoading = true;
                await request
                    .send(request.Apis.sales.customer.infoBaseEdit, {
                        ...this.form,
                        product: this.form.product.join(',')
                    })
                    .fin(() => {
                        this.submitLoading = false;
                    });
                this.$router.replace({ name: 'AdvertiserManagePrivateEditAderResult' });
            } catch (err) {
                this.$message.error(`添加失败：${err.message || '未知错误'}`);
            }
        },

        // 提交
        submitFormAction (form) {
            this.$refs[form].validate(valid => {
                if (valid) {
                    this.processCheckBigCustomer(flag => {
                        if (flag) {
                            this.processSubmit();
                        } else {
                            // 弹窗提示
                            this.$confirm('广告主名称和品牌都不在大客户名单内<br/>是否继续提交？', '提示', {
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '提交',
                                cancelButtonText: '取消',
                                type: 'warning',
                                center: true
                            }).then(() => {
                                this.processSubmit();
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },

        // 取消回退
        backAction () {
            this.$router.go(-1);
        }
    },
    created () {
        this.form.customer_id = this.$route.query.id || '';
        this._getDetail();
        this._fetchProduct();
    }
};
</script>

<style lang="less" scoped>
.form-box {
    width: 600px;

    .form-title {
        padding: 20px 0 24px 0;
    }

    .form-tip-icon {
        position: absolute;
        top: 11px;
        right: -32px;
        z-index: 2;
        width: 16px;
    }
}
</style>
